/* global UDO */
const jsonData = require('../data/tracking-data');
const CONSTANTS = require('./platform/constants.js').default;

let carData = null;
let userData = null;
let raqSubmitted = false;
const raqIsModal = window.Acr && window.Acr.backupTrackingObject;
window.Acr = window.Acr ? window.Acr : {};

// returns JSON object as a data-tracking attribute
function selectVehicleCta(tabName) {
  const object = JSON.parse(JSON.stringify(jsonData.selectVehicleCtaData));
  object['Event Metadata'].action_label = `${window.Acr.trackingObject.Page.page_name}:selector:${tabName}`;
  object['Event Metadata'].action_category = `${window.Acr.trackingObject.Page.page_name} request a quote selector`;
  return JSON.stringify(object);
}

// returns JSON object as a data-tracking attribute
function modelSelectorFilter(tabData) {
  const object = JSON.parse(JSON.stringify(jsonData.modelSelectorFilterData));
  const vehicleInfo = tabData.split(' ');
  object.Model.model_year = vehicleInfo[0];
  object.Model.model_name = vehicleInfo[1];
  object['Event Metadata'].action_label = `${window.Acr.trackingObject.Page.page_name}:selector:toggle filter ${vehicleInfo[1]}`;
  object['Event Metadata'].action_category = `${window.Acr.trackingObject.Page.page_name} selector`;
  return JSON.stringify(object);
}

// returns JSON object as a data-tracking attribute
function packageSelectorFilter(vehicleName, modelId) {
  const object = JSON.parse(JSON.stringify(jsonData.packageSelectorFilterData));
  const vehicleInfo = vehicleName.split(' ');
  object.Model.model_year = vehicleInfo[0];
  object.Model.model_name = vehicleInfo[1];
  object.Model.model_trim = modelId;
  object['Event Metadata'].action_label = `${window.Acr.trackingObject.Page.page_name}:selector:toggle filter ${vehicleInfo[1]}`;
  object['Event Metadata'].action_category = `${window.Acr.trackingObject.Page.page_name} selector`;
  return JSON.stringify(object);
}

// returns JSON object as a data-tracking attribute
function dealerSelection(label) {
  const object = JSON.parse(JSON.stringify(jsonData.changeDealerCtaData));
  object['Event Metadata'].action_label = `${window.Acr.trackingObject.Page.page_name}:${label}`;
  if (window.ModelData) {
    object.Model.model_name = window.ModelData.model;
    object.Model.model_year = window.ModelData.modelYear;
    delete object.Model.body_style;
    object.dynamic_variables = jsonData.dynamicVariables;
  } else {
    object.Model.model_name = 'no model';
    object.Model.model_year = 'no model';
    object.Model.body_style = 'no model';
    delete object.dynamic_variables;
  }
  return JSON.stringify(object);
}

// returns JSON object as a data-tracking attribute
function dealerPhone(dealer) {
  const object = JSON.parse(JSON.stringify(jsonData.dealerPhone));
  if (window.ModelData) {
    object.Model.model_name = window.ModelData.model;
    object.Model.model_year = window.ModelData.modelYear;
  } else {
    object.Model.model_name = 'no model';
    object.Model.model_year = 'no model';
    object.Model.body_style = 'no model';
  }
  object.Dealer.selected_dealer_id = dealer.dealerId;
  object.Dealer.selected_dealer_zipcode = dealer.zip;
  object.Dealer.selected_dealer_name = dealer.name;
  object.Dealer.selected_dealer_address = dealer.address;
  object.Dealer.selected_dealer_phone_number = dealer.phone;

  return JSON.stringify(object);
}

// returns JSON object as a data-tracking attribute
function dealerDirection(dealer) {
  const object = JSON.parse(JSON.stringify(jsonData.dealerDirection));
  if (window.ModelData) {
    object.Model.model_name = window.ModelData.model;
    object.Model.model_year = window.ModelData.modelYear;
  } else {
    object.Model.model_name = 'no model';
    object.Model.model_year = 'no model';
    object.Model.body_style = 'no model';
  }
  object.Dealer.selected_dealer_id = dealer.dealerId;
  object.Dealer.selected_dealer_zipcode = dealer.zip;
  object.Dealer.selected_dealer_name = dealer.name;
  object.Dealer.selected_dealer_address = dealer.address;

  return JSON.stringify(object);
}

// returns JSON object as a data-tracking attribute
function formSubmitButton() {
  const object = JSON.parse(JSON.stringify(jsonData.formSubmitButtonData));
  object['Event Metadata'].action_label = `${window.Acr.trackingObject.Page.page_name}:form:raq submit`;
  if (window.Acr.TrackingManager) {
    window.Acr.TrackingManager.clickActivity(object);
  }
}

// returns JSON object as a data-tracking attribute
function preferredDealer(isPreferred, userInfo) {
  let object = JSON.parse(JSON.stringify(jsonData.preferredDealerData));
  const preferredStatus = isPreferred ? 'select preferred dealer' : 'deselect preferred dealer';
  const Dealer = {
    Dealer: {
      selected_dealer_id: userInfo.localDealerId,
      selected_dealer_zipcode: userInfo.localDealerZip,
      selected_dealer_name: userInfo.localDealerName,
      selected_dealer_address: userInfo.localDealerAddress,
    },
  };

  object.dynamic_variables[2].search += preferredStatus;

  if (window.ModelData) {
    object.Model.model_name = window.ModelData.model;
    object.Model.model_year = window.ModelData.modelYear;
  }

  // Set Dealer Info
  object = Object.assign(Dealer, object);

  return JSON.stringify(object);
}

// used to get the quantity of months between a start date and a end date
function getMonthsBetween(start, end) {
  const startSplitted = start.split('-');
  const endSplitted = end.split('-');
  for (let i = 0; i < startSplitted.length; i++) {
    startSplitted[i] = parseInt(startSplitted[i], 10);
  }
  for (let i = 0; i < endSplitted.length; i++) {
    endSplitted[i] = parseInt(endSplitted[i], 10);
  }
  const date1 = new Date(startSplitted[0], startSplitted[1], startSplitted[2]);
  const date2 = new Date(endSplitted[0], endSplitted[1], endSplitted[2]);
  const year1 = date1.getFullYear();
  const year2 = date2.getFullYear();
  let month1 = date1.getMonth();
  let month2 = date2.getMonth();
  let result = 0;
  if (month1 === 0) {
    month1++;
    month2++;
  }
  result = ((year2 - year1) * 12) + (month2 - month1) + 1;
  return `${result} months`;
}

// returns a specific offer according to the offer id
function getOffer(offerId) {
  return window.offersData
    .find((ele) => ele.Id === offerId);
}

// gived a list of finance options, returns the finance term of each one separated by a pipe
function getFinanceTerm(financeList) {
  const resultList = [];
  financeList.forEach((e) => {
    resultList.push(`${e.TermMin} months - ${e.TermMax} months`);
  });
  return resultList.join(' | ');
}
// gived a list of finance options, returns the finance amount of each one separated by a pipe
function getFinanceAmount(financeList) {
  const resultList = [];
  financeList.forEach((e) => {
    resultList.push(`${e.APR}%`);
  });
  return resultList.join(' | ');
}
// gived an offer, returns the offer term and the offer amount according to the Sales Program Type
function getOfferPaymentDetails(offer) {
  const paymentDetails = { term: 0, amount: 0 };
  switch (offer.SalesProgramType.toLowerCase()) {
    case 'finance':
      if (offer.PaymentTerms && offer.PaymentTerms.FinanceTerms) {
        paymentDetails.term = getFinanceTerm(offer.PaymentTerms.FinanceTerms);
        paymentDetails.amount = getFinanceAmount(offer.PaymentTerms.FinanceTerms);
      }
      break;
    case 'lease':
      if (offer.LeasePaymentInfo) {
        paymentDetails.term = `${offer.LeasePaymentInfo.TermMonths} months`;
        paymentDetails.amount = offer.LeasePaymentInfo.BaseMonthlyPayment;
      }
      break;
    // types: Conquest, Military, AcuraLoyaltyAppreciation, AcuraLoyaltyConquest,
    // AcuraConquest, HCPV, Other
    default:
      paymentDetails.amount = offer.OfferAmount || 0;
      break;
  }
  return paymentDetails;
}
// generates the generic RAQ pageload
function generateBasePageloadObj(source) {
  let result = JSON.parse(JSON.stringify(jsonData.genericPageload));
  raqSubmitted = false;
  if (source === 'standalone' || !raqIsModal) {
    result = JSON.parse(JSON.stringify(jsonData.raqStandalonePageload));
  } else {
    // asking for window.Acr.backupTrackingObject to know wheter it is a modal or not.
    if (raqIsModal) {
      result.Page.page_name = `${window.Acr.backupTrackingObject.Page.page_name}:raq modal`;
    }
    if (carData && carData.name) {
      result.Page.sub_section2 = carData.name;
    }
  }
  if (window.dealerObject) {
    result.Dealer = {
      selected_dealer_id: window.dealerObject.DealerNumber,
      selected_dealer_zipcode: window.dealerObject.ZipCode,
      selected_dealer_name: window.dealerObject.Name,
      selected_dealer_address: window.dealerObject.Address,
      selected_dealer_phone_number: window.dealerObject.Phone,
    };
  }
  if (carData && carData.name && carData.year) {
    result.Model = {
      model_name: carData.name,
      model_year: carData.year,
    };
  }
  return result;
}

// RAQ MLP specific attributes
function addMlpAttributes(object) {
  const result = object;
  result.Page.site_section = 'vehicles';
  result.Page.sub_section = carData.name;
  result.Page.sub_section2 = 'overview';
  result.Model.model_id = window.ModelData.defaultTrim
    ? window.ModelData.defaultTrim : '';
}

// RAQ Payment Estimator specific attributes
function addPaymentEstimatorAttributes(object) {
  const result = object;
  result.Page.sub_section = 'estimate payments';
  result.Model.model_id = window.ModelData.modelId
    ? window.ModelData.modelId : '';
}

// RAQ Inventory specific attributes
function addInventoryAttributes(object) {
  const result = object;
  result.Page.sub_section = 'search inventory';
  result.Model.model_id = userData.modelId;
}

// RAQ Compare specific attributes
function addCompareAttributes(object) {
  const result = object;
  result.Page.sub_section = 'compare vehicles';
  result['Event Metadata'].tms_event = 'model_compare_view';
  result.Model.model_id = window.ModelData.modelId
    ? window.ModelData.modelId : '';
  result.Compare = { default_comp_model: window.compareData };
}

// RAQ Build and Price specific attributes
function addBuildAndPriceAttributes(object) {
  const result = object;
  const accessoriesData = JSON.parse(self.sessionStorage.getItem(CONSTANTS.accessoriesStorageKey));

  result.Page.sub_section = 'build and price';
  result.Model.model_id = window.ModelData.modelId
    ? window.ModelData.modelId : '';
  result.Model.selected_exterior_color = carData.colors.exterior.Name;
  result.Model.selected_interior_color = carData.colors.interior.Name;

  result.User = {
    selected_powertrain: carData.powertrains[1],
    selected_drivetrain: carData.powertrains[0],
    bap_interior_accessories: [],
    bap_exterior_accessories: [],
    bap_total_as_configured: window.bapTotalAmount,
  };

  if (accessoriesData) {
    accessoriesData.forEach((data) => {
      if (data.Type === 'I') {
        result.User.bap_interior_accessories.push(data.Name);
      } else {
        result.User.bap_exterior_accessories.push(data.Name);
      }
    });
  }
}

// RAQ Offers specific attributes
function addOffersAttributes(object) {
  const result = object;
  const selectedOffer = getOffer(userData.offerId[0]);
  const offerPaymentDetails = getOfferPaymentDetails(selectedOffer);
  result.Model = result.Model ? result.Model : {};
  result.Page.sub_section = 'current offers';

  if (userData && userData.modelId !== 'undefined') {
    result.Model.model_id = userData.modelId;
  }
  if (userData.modelId === 'undefined') {
    result.Model.model_name = 'no model';
    result.Model.model_year = 'no model';
    result.Model.body_style = 'no model';
  }
  result.Offer = {
    offer_type: selectedOffer.SalesProgramType,
    offer_amount: offerPaymentDetails.amount,
    offer_name: selectedOffer.SalesProgramName,
    offer_date: `${selectedOffer.StartDate} | ${selectedOffer.EndDate}`,
    offer_model: userData.carModelName || 'no model',
    offer_model_year: userData.carModelYear || 'no model',
    offer_id: selectedOffer.Id,
    offer_term: offerPaymentDetails.term,
    offer_duration: getMonthsBetween(selectedOffer.StartDate, selectedOffer.EndDate),
    offer_expire: selectedOffer.EndDate,
    offer_start: selectedOffer.StartDate,
  };
}

// returns JSON object as a data-tracking attribute
function vehicleCardInteraction(itemClicked) {
  const object = JSON.parse(JSON.stringify(jsonData.vehicleCardInteraction));
  object.dynamic_variables[0].search += itemClicked;
  // set model info
  if (window.ModelData) {
    object.Model.model_name = window.ModelData.model;
    object.Model.model_year = window.ModelData.modelYear;
  }
  if (window.Acr.TrackingManager) {
    window.Acr.TrackingManager.clickActivity(object);
  }
}

function abandonTracking() {
  const object = JSON.parse(JSON.stringify(jsonData.abandonData));
  if (!raqSubmitted) {
    if (window.ModelData) {
      object.Model.model_name = window.ModelData.model;
      object.Model.model_year = window.ModelData.modelYear;
    }
    if (window.Acr.TrackingManager) {
      window.Acr.TrackingManager.clickActivity(object);
    }
  }
}

function submitErrorTracking(inputName) {
  const object = JSON.parse(JSON.stringify(jsonData.submitErrorData));
  if (window.ModelData) {
    object.Model.model_name = window.ModelData.model;
    object.Model.model_year = window.ModelData.modelYear;
  }
  object.dynamic_variables[2].search += inputName;
  if (window.Acr.TrackingManager) {
    window.Acr.TrackingManager.clickActivity(object);
  }
}

function createPageloadObject(userInfo, carInfo) {
  userData = userInfo;
  carData = carInfo;
  const raqSource = userData.source && raqIsModal
    ? userData.source.toLowerCase() : 'standalone';
  const genericPageloadObj = generateBasePageloadObj(raqSource);
  genericPageloadObj.Model = genericPageloadObj.Model ? genericPageloadObj.Model : {};
  genericPageloadObj.Page = genericPageloadObj.Page ? genericPageloadObj.Page : {};

  switch (raqSource) {
    case 'mlp':
      addMlpAttributes(genericPageloadObj);
      break;
    case 'pe':
      addPaymentEstimatorAttributes(genericPageloadObj);
      break;
    case 'inventory-details':
    case 'inventory':
      addInventoryAttributes(genericPageloadObj);
      break;
    case 'compare':
      addCompareAttributes(genericPageloadObj);
      break;
    case 'bap':
      addBuildAndPriceAttributes(genericPageloadObj);
      break;
    case 'offers':
      addOffersAttributes(genericPageloadObj);
      break;
    default:
      break;
  }
  return genericPageloadObj;
}

function sendTrackingSuccess() {
  if (window.Acr.trackingObject
    && window.Acr.trackingObject.Page
    && window.Acr.trackingObject.Page.page_name) {
    window.Acr.trackingObject.Page.page_name += ' success';
  }
  if (window.ModelData && window.ModelData.model) {
    window.Acr.trackingObject.Model.model_name = window.ModelData.model;
    window.Acr.trackingObject.Model.model_year = window.ModelData.modelYear;
    window.Acr.trackingObject.Model.body_style = window.Acr.TrackingManager.getBodyStyle(window.Acr.trackingObject.Model.model_name);
  }

  raqSubmitted = true;
  window.Acr.TrackingManager.pageLoad();
}

const tracking = {
  selectVehicleCta,
  modelSelectorFilter,
  packageSelectorFilter,
  formSubmitButton,
  dealerSelection,
  preferredDealer,
  dealerDirection,
  dealerPhone,
  createPageloadObject,
  abandonTracking,
  submitErrorTracking,
  sendTrackingSuccess,
  vehicleCardInteraction,
};

module.exports = tracking;
